import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import FAQ from "./pages/FAQ";
import { Toaster } from "./components/ui/sonner";
import { initGA, trackPageView, initScrollTracking, initTimeTracking } from "./utils/analytics";

// Component to track page views
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Update page title based on route
    let pageTitle = "AddVantage - Advertising That Brings Profit";
    
    switch (location.pathname) {
      case '/':
        pageTitle = "AddVantage - Advertising That Brings Profit";
        break;
      case '/services':
        pageTitle = "Our Services - AddVantage";
        break;
      case '/faq':
        pageTitle = "FAQ - AddVantage";
        break;
      default:
        pageTitle = "AddVantage - Digital Marketing Agency";
    }
    
    document.title = pageTitle;
    
    // Track page view when route changes
    trackPageView(location.pathname, pageTitle);
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    initGA();
    
    // Initialize enhanced tracking
    initScrollTracking();
    initTimeTracking();
    
    // Remove Emergent branding
    const removeEmergentBranding = () => {
      // Remove any fixed position elements that might be the FAB
      const fixedElements = document.querySelectorAll('*[style*="position: fixed"]');
      fixedElements.forEach(el => {
        const style = el.getAttribute('style') || '';
        if (style.includes('bottom') && style.includes('right') && 
            (style.includes('z-index') || el.tagName === 'BUTTON' || el.tagName === 'DIV')) {
          // Check if it's not our navigation or modal
          if (!el.classList.contains('nav-glass') && !el.closest('.modal')) {
            el.style.display = 'none';
            el.remove();
          }
        }
      });
      
      // Also check for common FAB classes/ids
      const emergentSelectors = [
        '[data-testid*="emergent"]',
        '[class*="emergent"]', 
        '[id*="emergent"]',
        'iframe[src*="emergent"]'
      ];
      
      emergentSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          el.style.display = 'none';
          el.remove();
        });
      });
    };
    
    // Run immediately
    removeEmergentBranding();
    
    // Run periodically to catch dynamically added elements
    const interval = setInterval(removeEmergentBranding, 1000);
    
    // Cleanup
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <PageTracker />
        <Navigation />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;